export const CART_PAGE_URL = "/cart";
export const PRODUCTS_PAGE_URL = "/products";
export const COLLECTIONS_ALL_PAGE_URL = "/collections/all";
export const COLLECTIONS_PAGE_URL = "/collections";

// Classic accounts
export const LOGIN_PAGE_URL = "/account/login";
export const REGISTER_PAGE_URL = "/account/register";

// New accounts
export const CUSTOMER_AUTH_LOGIN_URL = "/customer_authentication/login";
